export default __webpack_public_path__ + "static/media/myprogress.e068ca59.png";